import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/** Returns today's date as "YYYY-MM-DD" in the user's local timezone. */
export function todayLocalDateString(): string {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function validateName(name: string): string | null {
  const n = name.trim()
  if (n.length < 2) return 'Name must be at least 2 characters'
  if (n.length > 50) return 'Name must be 50 characters or fewer'
  if (/[<>]/.test(n)) return 'Name contains invalid characters'
  return null
}
